"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcBreadcrumbBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_breadcrumb_constants_1 = require("./bc-breadcrumb-constants");
var bc_breadcrumb_constants_2 = require("./bc-breadcrumb-constants");
var bc_breadcrumb_constants_3 = require("./bc-breadcrumb-constants");
var bc_breadcrumb_constants_4 = require("./bc-breadcrumb-constants");
var bc_breadcrumb_constants_5 = require("./bc-breadcrumb-constants");
var bc_breadcrumb_constants_6 = require("./bc-breadcrumb-constants");
var bc_breadcrumb_constants_7 = require("./bc-breadcrumb-constants");
var bc_tooltip_behavior_1 = require("../../molecules/bc-tooltip/bc-tooltip-behavior");
var bc_float_menu_behavior_1 = require("../bc-float-menu/bc-float-menu-behavior");
var BcBreadcrumbBehavior = (function (_super) {
    __extends(BcBreadcrumbBehavior, _super);
    function BcBreadcrumbBehavior() {
        return _super.call(this) || this;
    }
    BcBreadcrumbBehavior.setUpAll = function () {
        var breadcrumbElements = Array.from(document.querySelectorAll(".".concat(bc_breadcrumb_constants_7.BC_BREADCRUMB)));
        return breadcrumbElements.map(function (element) {
            var bcBreadcrumbBehavior = new BcBreadcrumbBehavior();
            bcBreadcrumbBehavior.setElement(element);
            bcBreadcrumbBehavior.setUp();
            return bcBreadcrumbBehavior;
        });
    };
    BcBreadcrumbBehavior.prototype._setUp = function () {
        this.breadcrumbList = this.mySelf.querySelector(".".concat(bc_breadcrumb_constants_7.BREADCRUMB_ITEMS));
        this.initWindowState();
        this.changePageDetection();
        this.validateOverflowText();
        bc_float_menu_behavior_1.BcFloatMenuBehavior.setUpAll();
        bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
    };
    BcBreadcrumbBehavior.prototype.updateBreadcrumb = function (startIndex) {
        var breadcrumbItems = Array.from(this.breadcrumbList.getElementsByClassName(bc_breadcrumb_constants_7.BREADCRUMB_ITEM));
        var lastElement = breadcrumbItems[breadcrumbItems.length - 1];
        if (lastElement) {
            this.removeAccessibility(lastElement);
        }
        ;
        this.breadCrumbItemsList = breadcrumbItems;
        for (var i = startIndex; i < breadcrumbItems.length; i++) {
            this.breadcrumbList.appendChild(breadcrumbItems[i]);
        }
        this.validateMinimumItems();
    };
    ;
    BcBreadcrumbBehavior.prototype.validateMinimumItems = function () {
        var hideElement = this.breadcrumbList;
        if (this.breadcrumbList.childElementCount < bc_breadcrumb_constants_1.DOS) {
            hideElement.style.display = 'none';
        }
        else {
            hideElement.style.display = 'flex';
        }
    };
    BcBreadcrumbBehavior.prototype.updateFloatMenu = function () {
        this.clearFloatMenu();
        var floatMenuItem = document.createElement(bc_breadcrumb_constants_1.LI_TAG);
        var floatOptions = this.generateFloatMenuItems();
        if (floatOptions !== '') {
            floatMenuItem.className = bc_breadcrumb_constants_2.ITEM_MENU_CLASS;
            floatMenuItem.innerHTML = "\n      <button class=\"bc-icon-button bc-icon-button-ghost bc-icon-button-small bc-float-menu-toggle\">\n        <i class=\"bc-icon\">menu-dots-v</i>\n      </button>\n      <div class=\"bc-float-menu bc-float-menu-arrow-center\">\n        <div class=\"bc-float-menu-arrow\"></div>\n        <section class=\"bc-float-menu-content\">\n          <ul>\n            ".concat(floatOptions, "\n          </ul>\n        </section>\n      </div>\n    ");
            this.breadcrumbList.insertBefore(floatMenuItem, this.breadcrumbList.firstChild);
            this.floatMenuClickADetection();
        }
        this.addSeparationArrows();
    };
    ;
    BcBreadcrumbBehavior.prototype.generateFloatMenuItems = function () {
        var menuItemsHtml = '';
        this.filterFloatMenuItems();
        for (var i = 0; i < this.breadCrumbItemsList.length - this.mobileOption; i++) {
            this.breadCrumbItemsList[i].classList.add(bc_breadcrumb_constants_7.FLOAT_MENU_OPTIONS);
            this.removeAccessibility(this.breadCrumbItemsList[i]);
            menuItemsHtml += this.breadCrumbItemsList[i].outerHTML;
        }
        return menuItemsHtml;
    };
    ;
    BcBreadcrumbBehavior.prototype.clearFloatMenu = function () {
        var listItemElements = this.breadcrumbList.querySelectorAll(bc_breadcrumb_constants_1.LI_TAG);
        listItemElements.forEach(function (element) {
            if (element.classList.contains(bc_breadcrumb_constants_2.ITEM_MENU_CLASS)) {
                element.remove();
            }
        });
    };
    BcBreadcrumbBehavior.prototype.filterFloatMenuItems = function () {
        this.breadCrumbItemsList = this.breadCrumbItemsList.filter(function (element) {
            if (element.className.includes(bc_breadcrumb_constants_7.FLOAT_MENU_OPTIONS)) {
                return false;
            }
            return true;
        });
    };
    BcBreadcrumbBehavior.prototype.removeAccessibility = function (element) {
        var ref = element.querySelector(bc_breadcrumb_constants_1.A_TAG);
        ref.tabIndex = -1;
    };
    BcBreadcrumbBehavior.prototype.validateOverflowText = function () {
        var arrayBreadcrumbItem = this.mySelf.querySelectorAll(".".concat(bc_breadcrumb_constants_7.BREADCRUMB_ITEM));
        arrayBreadcrumbItem.forEach(function (item) {
            var link = item.querySelector(bc_breadcrumb_constants_1.A_TAG);
            var text = item.querySelector(bc_breadcrumb_constants_1.SPAN_TAG);
            var contentLink = text.textContent;
            if (contentLink.length > bc_breadcrumb_constants_3.MAX_CHARACTERS) {
                text.classList.add(bc_breadcrumb_constants_4.TOOLTIP_CLASS);
                link.classList.add(bc_breadcrumb_constants_6.TOOLTIP_ATTRIBUTE);
                link.setAttribute(bc_breadcrumb_constants_6.TOOLTIP_ATTRIBUTE, 'true');
                link.setAttribute(bc_breadcrumb_constants_6.TOOLTIP_TEXT_ATTRIBUTE, contentLink);
                link.setAttribute(bc_breadcrumb_constants_6.TOOLTIP_POSITION_ATTRIBUTE, bc_breadcrumb_constants_4.TOOLTIP_POSITION);
            }
            else {
                text.classList.remove(bc_breadcrumb_constants_4.TOOLTIP_CLASS);
                link.classList.remove(bc_breadcrumb_constants_6.TOOLTIP_ATTRIBUTE);
                link.removeAttribute(bc_breadcrumb_constants_6.TOOLTIP_ATTRIBUTE);
                link.removeAttribute(bc_breadcrumb_constants_6.TOOLTIP_TEXT_ATTRIBUTE);
                link.removeAttribute(bc_breadcrumb_constants_6.TOOLTIP_POSITION_ATTRIBUTE);
            }
        });
    };
    BcBreadcrumbBehavior.prototype.changePageDetection = function () {
        var _this = this;
        window.addEventListener(bc_breadcrumb_constants_5.EVENT_POPSTATE, function () {
            _this.changeBreadCrumb();
        });
    };
    BcBreadcrumbBehavior.prototype.floatMenuClickADetection = function () {
        var _this = this;
        var floatMenuOptions = this.mySelf.querySelectorAll(".".concat(bc_breadcrumb_constants_7.FLOAT_MENU_OPTIONS));
        floatMenuOptions.forEach(function (options) {
            options.addEventListener(bc_breadcrumb_constants_5.EVENT_CLICK, function () {
                _this.triggerRedirection(options);
            });
            options.addEventListener(bc_breadcrumb_constants_5.EVENT_KEYDOWN, function (event) {
                if (event.key === bc_breadcrumb_constants_5.EVENT_KEY) {
                    _this.triggerRedirection(options);
                }
            });
        });
    };
    BcBreadcrumbBehavior.prototype.triggerRedirection = function (option) {
        var link = option.querySelector(bc_breadcrumb_constants_1.A_TAG);
        var href = link.getAttribute(bc_breadcrumb_constants_6.HREF_ATTRIBUTE);
        if (href) {
            window.location.href = href;
        }
    };
    BcBreadcrumbBehavior.prototype.addSeparationArrows = function () {
        var breadcrumbLists = this.mySelf.querySelector(".".concat(bc_breadcrumb_constants_7.BREADCRUMB_ITEMS));
        var breadcrumbItem = breadcrumbLists.querySelectorAll(".".concat(bc_breadcrumb_constants_7.BREADCRUMB_ITEM, ":not(.").concat(bc_breadcrumb_constants_7.FLOAT_MENU_OPTIONS, ")"));
        var startIndex = this.breadCrumbItemsList.length > bc_breadcrumb_constants_1.TRES || this.mobileOption === 1 ? 0 : 1;
        for (var i = startIndex; i < breadcrumbItem.length; i++) {
            var link = breadcrumbItem[i].querySelector(bc_breadcrumb_constants_1.A_TAG);
            if (!breadcrumbItem[i].innerHTML.includes(bc_breadcrumb_constants_2.ICON_CLASS)) {
                link.insertAdjacentHTML('beforebegin', bc_breadcrumb_constants_7.SEPARATION_ARROW);
            }
            ;
        }
    };
    BcBreadcrumbBehavior.prototype.isMobile = function () {
        return window.outerWidth <= bc_breadcrumb_constants_3.MOBILE_WIDTH;
    };
    BcBreadcrumbBehavior.prototype.initWindowState = function () {
        this.changeBreadCrumb();
    };
    BcBreadcrumbBehavior.prototype.changeBreadCrumb = function () {
        this.clearMaximumBreadcrumbItems();
        this.mobileOption = (this.isMobile() ? 1 : bc_breadcrumb_constants_1.TRES);
        if (this.breadcrumbList) {
            this.updateBreadcrumb(this.breadcrumbList.childElementCount > this.mobileOption ? this.breadcrumbList.childElementCount - this.mobileOption : 0);
        }
        this.updateFloatMenu();
        this.cleanBreadCrumbList();
    };
    BcBreadcrumbBehavior.prototype.clearMaximumBreadcrumbItems = function () {
        if (this.breadcrumbList.childElementCount > bc_breadcrumb_constants_1.SEIS) {
            var listItems = this.breadcrumbList.querySelectorAll(bc_breadcrumb_constants_1.LI_TAG);
            for (var i = 6; i < listItems.length; i++) {
                listItems[i].remove();
            }
        }
    };
    BcBreadcrumbBehavior.prototype.cleanBreadCrumbList = function () {
        var floatMenuOptionElements = this.breadcrumbList.querySelectorAll("".concat(bc_breadcrumb_constants_1.LI_TAG, ".").concat(bc_breadcrumb_constants_7.FLOAT_MENU_OPTIONS));
        floatMenuOptionElements.forEach(function (element) {
            if (!element.closest("".concat(bc_breadcrumb_constants_1.LI_TAG, ".").concat(bc_breadcrumb_constants_2.ITEM_MENU_CLASS))) {
                element.remove();
            }
        });
    };
    return BcBreadcrumbBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcBreadcrumbBehavior = BcBreadcrumbBehavior;
